<template>
  <MembershipPage title="Just Need A Break?">
    <template #aboveBox>
      <div class="d-flex flex-column gap-sm">
        <p v-html="pauseCancelText"/>
        <p v-if="rentForLongerItems.length > 0">
          Pause to keep all perks and your quarterly rentals. If you cancel, your quarterly rentals
          will need to be returned.
        </p>
        <p v-else>
          Pause now and we’ll save everything for when you return.
        </p>
        <b>Pause my membership from {{ pauseDates.startDate }} to {{ pauseDates.endDate }}</b>
      </div>
      <div class="d-flex flex-column gap-sm align-items-center">
        <BaseButton
          :to="{ name: 'pause' }"
          text="Pause Membership"/>
        <BaseButton
          variant="text-link"
          :to="cancelRoute"
          text="I want to cancel my membership"/>
      </div>
    </template>
    <template #belowBox>
      <div class="px-md">
        <BaseAccordion
          v-for="faq in pauseCancelFaqs"
          :key="faq.id"
          chevron-placement="right"
          class="text-start">
          <template #title>
            <p
              class="semi-bold py-sm"
              v-html="faq.question"/>
          </template>
          <div v-if="faq.hasCustomContent && faq.id === 'other-questions'">
            <p>
              <TextLink
                size="paragraph"
                variant="primary"
                type="a"
                name="Chat with customer support"
                @click="initiateChatClick">
                Chat
              </TextLink>
              with our customer support team to address any outstanding questions.
            </p>
          </div>
          <p
            v-else
            class="faq-answer"
            v-html="faq.answer"/>
        </BaseAccordion>
      </div>
    </template>
  </MembershipPage>
</template>

<script setup>
import MembershipPage from '@/components/account/membership/new/MembershipPage.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import BaseAccordion from '@shared/components/ADORN/BaseAccordion.vue'
import TextLink from '@/components/global/sequin/TextLink.vue'
import { computed, onMounted } from 'vue'
import { usePauseCancel } from '@/composables/pauseCancel.js'
import useAnalytics from '@shared/composables/analytics.js'

const {
  pauseDates,
  pauseCancelText,
  getBilling,
  pauseCancelFaqs,
  availablePerks,
  rentForLongerItems,
  getItemPromotions
} = usePauseCancel()
const { trackPageViewEvent } = useAnalytics()

const cancelRoute = computed(() => {
  return availablePerks.value.length > 0 
    ? { name: 'cancel-benefits' } 
    : { name: 'cancel' }
})

onMounted(async () => {
  trackPageViewEvent('Pause or Cancel')
  await getBilling()
  await getItemPromotions()
})

const initiateChatClick = () => {
  window.Intercom('showNewMessage')
}
</script>

<style lang="scss" scoped>
.faq-answer {
  white-space: pre-line;
}

</style>
